import Cookies from "js-cookie";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { POST } from "../../../utils/Methods";
import { APIS } from "../../../utils/APIS";
import { IDS } from "../../../utils/IDS";

// 🔹 LOGIN
export const CreateLogin = createAsyncThunk(
  "auth/login",
  async (data, { rejectWithValue }) => {
    try {

      const res = await POST(APIS.Auth.login, data);


      if (res?.success && res?.data?.token) {
        Cookies.set("omtapovan_website_security", res.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });
        console.log(" Token saved in cookies:", res.data.token);
      } else {
        console.warn(" No token found in login response");
      }

      console.log(
        " Current cookie value:",
        Cookies.get("omtapovan_website_security")
      );
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      console.error(" Login API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// 🔹 SIGNUP
export const CreateSignup = createAsyncThunk(
  "auth/signup",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.signup, data);

      // console.log({ res });


      // optional: store token if returned
      if (res?.success && res?.data?.token) {
        Cookies.set("omtapovan_website_security", res.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });
        console.log(" Token saved from signup:", res.data.token);
        return res
      }

      return rejectWithValue(res);
    } catch (error) {
      console.error(" Signup API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// Thunk for sending OTP
export const sendMobileOtp = createAsyncThunk(
  "auth/sendOtp",
  async (data, { rejectWithValue }) => {
    try {
      console.log("sendOtp", data);

      const otp = await POST(APIS.Auth.SEND_OTP, data);

      console.log("otp", otp);
      if (otp?.success) {

        return otp;
      }
      return rejectWithValue(otp);
    } catch (error) {
      console.log(error, "error error");

      return rejectWithValue(error?.response?.data);
    }
  }
);

// Thunk for verifying login
export const verifyOtp = createAsyncThunk(
  "auth/verifyotp",
  async (data, { rejectWithValue }) => {
    try {
      console.log("verifyOtp", data);

      const response = await POST(APIS.Auth.VERIFY_OTP, data);

      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const SendOtpResetPassword = createAsyncThunk(
  "auth/email-contact-otp-send",
  async (data, { rejectWithValue }) => {
    try {
      console.log("sendOtp", data);

      const otp = await POST(APIS.Auth.SEND_OTP_FOR_RESET, data);

      console.log("otp", otp);

      return otp;
      //   return rejectWithValue(otp);
    } catch (error) {
      console.log(error, "error error");

      return rejectWithValue(error);
    }
  }
);


export const VerifyOtpResetPassword = createAsyncThunk(
  "auth/email-contact-verify-otp",
  async (data, { rejectWithValue }) => {
    try {
      console.log("verifyOtp", data);

      const response = await POST(APIS.Auth.VERIFY_OTP_FOR_RESET, data);

      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const SetPassword = createAsyncThunk(
  "auth/forgot-password",
  async (data, { rejectWithValue }) => {
    try {

      const response = await POST(APIS.Auth.SET_PASSWORD, data);

      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);





export const LoginSlice = createSlice({
  name: "login",
  initialState: {
    loginData: null,
    loginStatus: IDS.SLICESTATUS.Idle,
    loginError: null,

    signupData: null,
    signupStatus: IDS.SLICESTATUS.Idle,
    signupError: null,

    sendOtpData: null,
    sendOtpStatus: IDS.SLICESTATUS.Idle,
    sendOtpError: null,

    verifyOtpData: null,
    verifyOtpStatus: IDS.SLICESTATUS.Idle,
    verifyOtpError: null,

    setPasswordData: null,
    setPasswordStatus: IDS.SLICESTATUS.Idle,
    setPasswordError: null,
  },
  reducers: {
    logoutUser: (state) => {
      Cookies.remove("omtapovan_website_security");
      Cookies.remove("language_id");
      state.loginData = null;
      state.signupData = null;
      state.loginStatus = IDS.SLICESTATUS.Idle;
      state.signupStatus = IDS.SLICESTATUS.Idle;
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔹 LOGIN
      .addCase(CreateLogin.pending, (state) => {
        state.loginStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateLogin.fulfilled, (state, action) => {
        state.loginStatus = IDS.SLICESTATUS.Succeeded;
        state.loginData = action.payload?.data || null;
      })
      .addCase(CreateLogin.rejected, (state, action) => {
        state.loginStatus = IDS.SLICESTATUS.Failed;
        state.loginError = action.payload;
      })

      // 🔹 SIGNUP
      .addCase(CreateSignup.pending, (state) => {
        state.signupStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateSignup.fulfilled, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Succeeded;
        state.signupData = action.payload?.data || null;
      })
      .addCase(CreateSignup.rejected, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Failed;
        state.signupError = action.payload;
      })

      .addCase(SendOtpResetPassword.pending, (state) => {
        state.sendOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(SendOtpResetPassword.fulfilled, (state, action) => {
        state.sendOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.sendOtpData = action.payload?.data || null;
      })
      .addCase(SendOtpResetPassword.rejected, (state, action) => {
        state.sendOtpStatus = IDS.SLICESTATUS.Failed;
        state.sendOtpError = action.payload;
      })

      // Verify OTP
      .addCase(VerifyOtpResetPassword.pending, (state) => {
        state.verifyOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(VerifyOtpResetPassword.fulfilled, (state, action) => {
        state.verifyOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.verifyOtpData = action.payload?.data || null;
      })
      .addCase(VerifyOtpResetPassword.rejected, (state, action) => {
        state.verifyOtpStatus = IDS.SLICESTATUS.Failed;
        state.verifyOtpError = action.payload;
      })


      .addCase(SetPassword.pending, (state) => {
        state.setPasswordStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(SetPassword.fulfilled, (state, action) => {
        state.setPasswordStatus = IDS.SLICESTATUS.Succeeded;
        state.setPasswordData = action.payload?.data || null;
      })
      .addCase(SetPassword.rejected, (state, action) => {
        state.setPasswordStatus = IDS.SLICESTATUS.Failed;
        state.setPasswordError = action.payload;
      });


  },
});

export const { logoutUser } = LoginSlice.actions;
export default LoginSlice.reducer;
